import { PureComponent } from 'react';
import moment from 'moment'
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import { Settings } from '@dbk/ui-icons';
import { TextInput, NumericInput, Radio, Message } from '@dbk/ui-forms';
import Select from '@dbk/ui-select';
import Text from '@dbk/ui-text';
import { DatePicker } from '@dbk/ui-datepicker';
import InverseProvider from '@dbk/ui-inverse';
import 'moment/min/locales';
import { PALETTE, KEY_CODE, PAYMENT_DATE_TYPE } from '../../../../constants';
import { convertStringArrayToObjectArray as convert, convertAndSortDropDown, convertKeyToLabelArray, convertKeyToLabelArrayForInitiator, convertCurrencyDropdown } from '../../payment-utils';
import BlurModal from '../../../../components/common/blur-modal';
import { LoadingCircle } from '../../../../components/common/loading';
import { today, weekAgo, monthAgo, formatToISODate, formatDateShortMonth } from '../../../../utils/date';
import {
    FILTER_ICON_STYLE,
    PAYMENT_RANGE_TODAY,
    PAYMENT_RANGE_ONE_WEEK,
    PAYMENT_RANGE_ONE_MONTH,
    PAYMENT_RANGE_RANGE,
    PAYMENT_RANGE_OPTIONS
} from '../../constant';

const initOpts = {
    currencyList: [],
    portfolioList: [],
    debitAccountList: [],
    beneficiaryName: '',
    paymentTypeList: [],
    paymentStatusList: [],
    initiatorList: [],
    selectedExecDate: '',
    execFromDate: null,
    execToDate: null,
    amountFrom: '',
    amountTo: '',
    filters: ['selectedDate'],
    showFilter: false,
    isDateRangeActive: false,
    selectedDate: PAYMENT_DATE_TYPE.EXECUTION_DATE
}

const clearedFilters = {
    selectedExecDate: '',
    execFromDate: '',
    execToDate: '',
    showFilter: true,
    dateRange: { from: null, to: null },
}
class PaymentMultiSignFilter extends PureComponent {
    constructor(props) {
        super(props);
    }

    initialState = Object.assign(
        {
            multiSignDebitAccountListData: null,
            dateRange: {
                from:
                    this.props.payments.multiSignFilterOptions?.execFromDate
                        ? moment(this.props.payments.multiSignFilterOptions.execFromDate).toDate()
                        : this.props.payments.multiSignFilterOptions?.conclusionFromDate
                            ? moment(this.props.payments.multiSignFilterOptions.conclusionFromDate).toDate()
                            : null,
                to: this.props.payments.multiSignFilterOptions?.execToDate
                    ? moment(this.props.payments.multiSignFilterOptions.execToDate).toDate()
                    : this.props.payments.multiSignFilterOptions?.conclusionToDate
                        ? moment(this.props.payments.multiSignFilterOptions.conclusionToDate).toDate()
                        : null,
            },
            selectedDay: moment(this.props.payments.startDate),
        },
        initOpts,
        this.props.payments.multiSignFilterOptions
        );
        // Assign to state
        state = { ... Object.assign({}, this.initialState) };

    componentDidUpdate(prevProps) {
        if (this.props.reports.closeDatePicker === true && this.datepickerRef && this.datepickerRef.datepicker && this.datepickerRef.datepicker.state && this.datepickerRef.datepicker.state.isOpen) {
            this.onCancel();
        }
        if (this.state.dateRange.from && this.state.dateRange.to && this.state.selectedExecDate === 'range') {
            setTimeout(() => {
                if (document.querySelector('#applybtnFocus')) {
                    document.querySelector('#applybtnFocus').focus();
                }
                this.setState({ isDateRangeActive: true });
            }, 100);
        }
        const configs = [
            { propKey: 'multiSignPaymentTypeListData', stateKey: 'paymentTypeList' },
            { propKey: 'multiSignStatusListData', stateKey: 'paymentStatusList' },
            { propKey: 'multiSignCurrencyListData', stateKey: 'currencyList' }
        ];

        configs.forEach(({ propKey, stateKey }) => {
            if (prevProps.payments[propKey] !== this.props.payments[propKey] && this.state.filters.includes(stateKey)) {
                const updatedList = this.state[stateKey].map(item => {
                    const match = this.props.payments[propKey].find(data => data.key === item.key);
                    return match
                        ? { ...item, value: match.value, label: match.value }
                        : item;
                }
                )
                this.setState({
                    [stateKey]: updatedList
                });
            }
        })
    }

    onCancel = () => {
        this.datepickerRef.close();
        this.props.setDatePickerClose(false);
    }

    onFilterChange = (selectedItem, selectedItems, key) => {
        this.setState({ [key]: selectedItems })
        this.setFilter(key, selectedItem, selectedItems)
    }

    onClearClick = () => {
        const { payments: { multiSignDebitAccountListData } } = this.props;
        this.setState(prevState => ({
            ...initOpts,
            ...clearedFilters,
            multiSignDebitAccountListData,
        }))
        // setFilterFlag(false);
        // setFilterOptions(null);
        // setFilteredPayments(null);
    }

    onApplyClick = () => {
        const { payments: { setFilterOptions } } = this.props;
        const {
            filters, execFromDate, execToDate, selectedExecDate, conclusionFromDate, conclusionToDate } = this.state;
        const options = {};
        options.selectedExecDate = selectedExecDate;
        let localFilter = this.state.filters;
        for (const filter of filters) {
            if (filter === 'date') {
                if (selectedExecDate === 'range') {
                    if ((this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE)&& (execFromDate && execToDate) ) {
                        options.execFromDate = formatToISODate(execFromDate);
                        options.execToDate = formatToISODate(execToDate);
                    } else if (conclusionFromDate && conclusionToDate   ) {
                        options.conclusionFromDate = formatToISODate(conclusionFromDate);
                        options.conclusionToDate = formatToISODate(conclusionToDate);
                    }else {
                        localFilter = localFilter.filter(f => f !== 'date');
                        // this.setState(prevState => ({
                        //   filters: prevState.filters.filter(f => f !== 'date'),
                        //   selectedExecDate: ''
                        // }));
                    }
                } else {
                    if (this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE) {
                        options.execFromDate = execFromDate
                        options.execToDate = execToDate
                    } else {
                        options.conclusionFromDate = conclusionFromDate
                        options.conclusionToDate = conclusionToDate
                    }
                }
            } else {
                options[filter] = this.state[filter];
            }
        }
        options.filters = localFilter;
        setFilterOptions(options);

        const opts = { ...options };
        const arrayObj = Object.fromEntries(
          Object.entries(opts)
            .filter(([key, value]) => key !== 'filters' && Array.isArray(value))
            .map(([key, arr]) => [key, arr.map(item => item.key)])
        );

        const otherFilterObj = Object.fromEntries(
          Object.entries(opts)
            .filter(([key, value]) => !Array.isArray(value) && key !== 'selectedDate' &&
              key !== 'selectedExecDate')
        );

        const filterLookupObj = { ...arrayObj, ...otherFilterObj };
        this.props.payments.applyFilter(filterLookupObj);
        this.toggleFilter(false, options);
        this.initialState = { ...this.state };
    }

    setSelectionDateType = execDate => {
        let execFromDate;
        let filterFromDate = this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE ? 'execFromDate' : 'conclusionFromDate';
        let filterToDate = this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE ? 'execToDate' : 'conclusionToDate';
        //  //WMCE-45985- to resolve the filter on date for german language
        if (execDate === PAYMENT_RANGE_TODAY) {
            execFromDate = today
        } else if (execDate === PAYMENT_RANGE_ONE_WEEK) {
            execFromDate = weekAgo
        } else if (execDate === PAYMENT_RANGE_ONE_MONTH) {
            execFromDate = monthAgo
        }
        if (execDate !== PAYMENT_RANGE_RANGE) {
            this.setState({
                isDateRangeActive: false,
                selectedExecDate: execDate,
                [filterFromDate]: execFromDate,
                [filterToDate]: today,
                dateRange: {
                    from: execFromDate ? moment(execFromDate).toDate() : null,
                    to: moment().toDate()
                }
            });
        } else {
            this.setState({
                selectedExecDate: execDate,
                isDateRangeActive: true,
                dateRange: {
                    from: null,
                    to: null
                }
            })
        }
        if (!this.state.filters.includes('date')) {
            this.setState(prevState => ({
                ...prevState,
                filters: prevState.filters.concat('date')
            }))
        }
    }

    setFilter = (filterType, value, selectedItems) => {
        const { filters } = this.state;
        let updatedFilters = [...filters];

        if (!updatedFilters.includes(filterType)) {
            updatedFilters.push(filterType);
        } else if (selectedItems.length === 0) {
            updatedFilters = updatedFilters.filter(f => f !== filterType);            
        }
        this.setState({ filters: updatedFilters });
    }

    toggleFilter = (show, options, e) => {
        if ((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)) {
            this.setState({ showFilter: show }, async function () {
                if (show) {
                    this.props.payments.fetchFilterListsLookup();
                }
                else {
                    const filterOptions = (options.filters) ? options : this.props.payments.multiSignFilterOptions;
                    const obj = Object.assign(
                        {},
                        initOpts,
                        filterOptions)
                    this.setState({
                        ...obj,
                        filters: filterOptions ? filterOptions.filters : ['amount']
                    })
                }
            })
            setTimeout(() => {
                if (document.querySelector('button.paymentFilterFocus')) {  // Button focusable for payment filter popup
                    document.querySelector('button.paymentFilterFocus').focus();
                }
            }, 1000)
        }
    }

    hideDateRangeModal = () => {
        const { execFromDate, execToDate } = this.state;
        this.setState(() => ({
            dateRange: {
                from: execFromDate ? moment(execFromDate).toDate() : null,
                to: execToDate ? moment(execToDate).toDate() : null
            }
        }));
        this.datepickerRef.close();
    };

    onDateApply = () => {
        let date = this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE ? 'exec' : 'conclusion';
        const { dateRange } = this.state;
        this.setState({
            [date + 'FromDate']: dateRange.from ? formatDateShortMonth(dateRange.from) : null,
            [date + 'ToDate']: dateRange.to ? formatDateShortMonth(dateRange.to) : null,
        });
        this.datepickerRef?.close();
    }

    onChangeRange = (range) => {
        this.setState({
            dateRange: {
                ...this.state.dateRange,
                ...range
            }
        });
    };

    customFooter = () => {
        const { i18n: { messages } } = this.props;
        const { dateRange: { from, to } } = this.state;
        return <InverseProvider inverse className="customFooterParent">
            <div className="datepicker-footer-txt" tabIndex={0}>
                <Text className="customFooterToday">{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
            </div>
            <div className="datepicker-footer-btn">
                <Button tertiary
                    onClick={() => this.hideDateRangeModal()}
                >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

                <Button
                    id="selectBtnFocus"
                    onClick={() => this.onDateApply()}
                    disabled={!(from && to)}
                >{messages['app.reports.orderReport.accountPortfolioPlaceholder']}</Button>
            </div>
        </InverseProvider>
    }

    onRadioSelectedViewByDate = (value) => {
        const { selectedExecDate } = this.state;
        this.setState({
            selectedDate: value
        }, function () {
            if (selectedExecDate === 'range') this.onDateApply()
            if (selectedExecDate != '') this.setSelectionDateType(selectedExecDate)
        })
        this.setFilter('selectedDate', '', value);
    }

    getFilterCount = () => {
        const filters = this.state.filters;
        let count = 0;
        if (filters.includes('amountFrom') || filters.includes('amountTo')) {
            count += 1;
        }
        if (filters.includes('selectedDate') && filters.includes('date')) {
            count += 1;
        }
        const otherFilters = filters.filter(f => f !== 'amountFrom' && f !== 'amountTo' && f !== 'selectedDate' && f !== 'date');
        count += otherFilters.length;
        return count;
    }

    onCloseModal = () => {
        this.setState({ showFilter: false,  ...this.initialState });
    }

    renderDateRangeOptionBtns = (key) => (
        <div className="btn_seg columns large-3">
            <Button
                tabIndex={0}
                className="paymentFilterFocus"
                tertiary={this.state.selectedExecDate !== key}
                fullWidth
                onPress={() => this.setSelectionDateType(key)}
            >
                {this.props.i18n.messages['app.payment.filter.' + key]}
            </Button>
        </div>
    );

    renderSelectDropdown = ({
        label,
        stateKey,
        options,
        onChange
    }) => {
         const {
            i18n: { messages }
        } = this.props;
        return (
        <div className="columns large-6">
            <div className='margin-bottom-5'>
                <Text secondary className="margin-bottom-10 paymentHeading" tabIndex={0}>{label}</Text>
            </div>
            <div>
                <Select
                    tabIndex='0'
                    size='large'
                    defaultLabel={messages['app.common.select']}
                    selectedItems={this.state[stateKey]}
                    options={options}
                    fullWidth
                    onChange={onChange || ((selectedItem, selectedItems) =>
                        this.onFilterChange(selectedItem, selectedItems, stateKey)
                    )}
                    labelForReader={label}
                    // accessible label to be added
                />
            </div>
        </div>
    );
}

    handleAmountRangeBlur = () =>   {
        if(parseFloat(this.state.amountFrom) > parseFloat(this.state.amountTo))
            this.setState({ error: true });
        else
            this.setState({ error: false });
    }

    render() {
        const {
            i18n: { messages },
            payments: {
                multiSignPortfolioListData,
                multiSignPaymentTypeListData,
                multiSignCurrencyListData,
                multiSignStatusListData,
                multiSignDebitAccountListData,
                initiatorListData
            }} = this.props;
        const {
            beneficiaryName,
            selectedExecDate,
            filters,
            showFilter,
            dateRange,
        } = this.state;

        const filterCount = this.getFilterCount();

        const isLoaded = multiSignPortfolioListData && this.props.payments.multiSignDebitAccountListData && multiSignPaymentTypeListData && multiSignCurrencyListData && multiSignStatusListData;

        const currencyData = convertCurrencyDropdown(multiSignCurrencyListData);
        const portfolioData = convert(multiSignPortfolioListData);
        const debitAccountData = convertAndSortDropDown((multiSignDebitAccountListData || this.props.payments.multiSignDebitAccountListData), ["psActNo", "psPosId", "pfId"]);
        const paymentTypeData = convertKeyToLabelArray(multiSignPaymentTypeListData);
        const paymentStatusData = convertKeyToLabelArray(multiSignStatusListData);
        const multiSignInitiatorData = convertKeyToLabelArrayForInitiator(initiatorListData, this.props.auth.userId);
        const pageTitle = `${messages['app.payment.pageTitle.filterPayment']} (${filterCount})`;

        return (
            <>
                <span className={'paymentListFilter pointer flex-ai-center margin-left-15'} role="button" onKeyDown={(e) => this.toggleFilter(true, "", e)} onClick={() => this.toggleFilter(true)} tabIndex="0" aria-label={messages['app.payment.filterButton']}>
                    <Settings id="filter" width={FILTER_ICON_STYLE.WIDTH} height={FILTER_ICON_STYLE.HEIGHT} color={filterCount > 0 ? PALETTE.primaryActive : PALETTE.secondaryActive} />
                    <Text className='paymentFilterBadge'> {filterCount > 0 && `(${filterCount})`}</Text>
                </span>
                <BlurModal
                    onDone={() => {
                        this.setState({ showFilter: false }, this.onCloseModal())
                    }}
                    visible={showFilter}
                    size="large"
                    title={pageTitle}
                    disableOutsideClick={true}
                    className={"filter-modal-payments"}
                >
                    <div className="payment-filter-input">
                        {!isLoaded && <LoadingCircle />}
                        {isLoaded && <div className="row" >
                            <div className="columns large-12 pymntFilterContentBgCol">
                                <div className="row">
                                    <Text className="columns large-12 margin-bottom-10" tabIndex="0" aria-label={messages['app.payment.filter.pymtExecDateMultisig'] + messages['app.payment.pageTitle.filterPayment']}>{messages['app.payment.filter.pymtExecDateMultisig']}</Text>
                                </div>
                                <div className="row">
                                    {/* Filter range selection today, one week, one month and range */}
                                   {PAYMENT_RANGE_OPTIONS.map(key => this.renderDateRangeOptionBtns(key))}

                                    {this.state.isDateRangeActive &&
                                        <div className="paymentFilter input-container" aria-label={messages['app.payment.dateRangeCalender']} >
                                            <DatePicker
                                                aria-label={messages['app.payment.dateRangeCalender']}
                                                ref={(ref) => this.datepickerRef = ref}
                                                tetherProps={{ attachment: "top center", targetAttachment: "bottom center" }}
                                                showOutsideMonthDays={false}
                                                enableYearNavigation
                                                enableRangeSelection
                                                onChange={this.onChangeRange}
                                                value={dateRange}
                                                startDate={moment().add(-2, 'years').toDate()}
                                                endDate={moment().add(4, 'years').toDate()}
                                                inputDateFormat={'dd MMM yyyy'}
                                                selectionStart={dateRange.from}
                                                selectionEnd={dateRange.to}
                                                disableWeekendDays
                                                renderFooter={() => this.customFooter()}
                                                locale={this.props.auth.langCode}
                                                weekStartsOn={1} // Monday is the first day of the week.
                                            />
                                        </div>
                                    }
                                </div>
                                <div className="row filterRowsMargin">
                                    <div className='columns margin-bottom-5'>
                                        <Text secondary className="margin-bottom-10 paymentHeading" tabIndex={0}> {messages['app.payments.filter.on']} </Text>
                                        <Radio
                                            title={messages['app.payment.beneDetail.executionDate']}
                                            className="margin-left-20"
                                            value="VALUE"
                                            checked={this.state.selectedDate === PAYMENT_DATE_TYPE.EXECUTION_DATE}
                                            onChange={() => this.onRadioSelectedViewByDate(PAYMENT_DATE_TYPE.EXECUTION_DATE)}
                                        />
                                        <Text tabIndex={0}>{messages['app.payment.beneDetail.executionDate']}</Text>
                                        <Radio
                                            title={messages['app.payments.conclusion.date']}
                                            className="margin-left-20"
                                            value="VALUE"
                                            checked={this.state.selectedDate === PAYMENT_DATE_TYPE.CONCLUSION_DATE}
                                            onChange={() => this.onRadioSelectedViewByDate(PAYMENT_DATE_TYPE.CONCLUSION_DATE)}
                                        />
                                        <Text tabIndex={0}>{messages['app.payments.conclusion.date']}</Text>
                                    </div>
                                </div>
                                <div className="row filterRowsMargin">
                                    <div className='columns margin-bottom-5'>
                                        <Text tabIndex={0}> {messages['app.payment.filter.pymtAmount']} </Text>
                                    </div>
                                </div>
                                <div className="row filterRowsMargin margin-bottom-40">
                                    <div className="columns large-6">
                                        <div className='margin-bottom-5'>
                                            <Text secondary className="margin-bottom-10 paymentHeading" tabIndex={0}> {messages['app.payments.destination.from']} </Text>
                                        </div>
                                        <div>
                                            <NumericInput
                                                tabIndex="0"
                                                value={this.state.amountFrom}
                                                size="large"
                                                placeholder={messages['app.payment.filter.amount.range.start']}
                                                placeholderTextColor={PALETTE.primaryText}
                                                onChange={text => this.onFilterChange(text.target.value, text.target.value, 'amountFrom')}

                                            />
                                        </div>
                                    </div>
                                    <div className="columns large-6">
                                        <div className='margin-bottom-5'>
                                            <Text secondary className="margin-bottom-10 paymentHeading" tabIndex={0}> {messages['app.payments.destination.to']} </Text>
                                        </div>
                                        <div>
                                            <NumericInput
                                                tabIndex="0"
                                                value={this.state.amountTo}
                                                size="large"
                                                placeholder={messages['app.payment.filter.amount.range.end']}
                                                placeholderTextColor={PALETTE.primaryText}
                                                error={this.state.error}
                                                onBlur={this.handleAmountRangeBlur} 
                                                onChange={text => this.onFilterChange(text.target.value, text.target.value, 'amountTo')}
                                            />
                                            {this.state.error &&
                                                <Message type="error">
                                                    {messages['app.payment.filter.amount.range.error']}
                                                </Message>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="row filterRowsMargin">
                                    {this.renderSelectDropdown({
                                        label: messages['app.payment.filter.pymtCurrency'],
                                        stateKey: 'currencyList',
                                        options: currencyData
                                    })}
                                    {this.renderSelectDropdown({
                                        label: messages['app.payment.filter.portfolio'],
                                        stateKey: 'portfolioList',
                                        options: portfolioData
                                    })}
                                </div>
                                <div className="row filterRowsMargin">
                                    {this.renderSelectDropdown({
                                        label: messages['app.payment.filter.debitAccount'],
                                        stateKey: 'debitAccountList',
                                        options: debitAccountData
                                    })}
                                    <div className="columns large-6 ">
                                        <div className='margin-bottom-5'>
                                            <Text secondary className="paymentHeading" tabIndex={0}> {messages['app.payment.filter.beneName']} </Text>
                                        </div>
                                        <div>
                                            <TextInput
                                                tabIndex="0"
                                                value={beneficiaryName}
                                                size="small"
                                                onChange={text => this.onFilterChange(text.target.value, text.target.value, 'beneficiaryName')}
                                                className="searchInput"
                                                title={messages['app.payment.filter.beneName']}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row filterRowsMargin">
                                    {this.renderSelectDropdown({
                                        label: messages['app.payment.filter.pymtType'],
                                        stateKey: 'paymentTypeList',
                                        options: paymentTypeData
                                    })}

                                    {this.renderSelectDropdown({
                                        label: messages['app.payment.filter.pymtStatus'],
                                        stateKey: 'paymentStatusList',
                                        options: paymentStatusData
                                    })}
                                </div>
                                <div className="row filterRowsMargin">
                                    {this.renderSelectDropdown({
                                        label: messages['app.payment.filter.multisign.submitter'],
                                        stateKey: 'initiatorList',
                                        options: multiSignInitiatorData
                                    })}
                                </div>
                                <div className="row ">
                                    <div className="btn">
                                        <Button size="large" disabled={this.state.error} onPress={this.onApplyClick}>
                                            {messages['app.payment.filter.applyButton']}
                                        </Button>
                                    </div>
                                    <div className="btn">
                                        <Button size="large" tertiary onPress={this.onClearClick}>
                                            {messages['app.payment.filter.clearButton']}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </BlurModal>
            </>
        );
    }
}

export default createContainer({
    $queries: {
        changePage: { $call: 'ui.history.push' },
        i18n: {
            messages: true,
        },
        payments: {
            transactionListLoading: true,
            setFilterFlag: { $set: 'multiSignFilterFlag' },
            multiSignPortfolioListData: true,
            multiSignDebitAccountListData: true,
            multiSignPaymentTypeListData: true,
            multiSignStatusListData: true,
            multiSignCurrencyListData: true,
            initiatorListData: true,
            multiSignFilterOptions: true,
            applyFilter: { $call: 'applyMultiSignFilter' },
            setFilterOptions: { $set: 'multiSignFilterOptions' },
            fetchFilterListsLookup: { $call: 'fetchFilterListsLookup' }
        },
        auth: {
            langCode: true,
            userId: true
        },
        reports: {
            closeDatePicker: true
        },
        setDatePickerClose: {
            $set: 'reports.closeDatePicker'
        },
        app: {
            user: {
                portfoliosData: true
            }
        }
    },
}
)(PaymentMultiSignFilter);
